export const hyphenateString = (string: string) =>
  string.replaceAll(' ', '-').toLocaleLowerCase()
